module.exports = __webpack_public_path__ + "img/andreas-dress-1406323-unsplash.2f2ff6a8.jpg";